import React, { useState } from "react";
import { Form, FormLabel, Row, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { editEvaluationTypeCheck } from "../../redux/evaluacion_desempenio/EvaluationType/actions";

const CheckRequired = (props) => {
  const [loading, setLoading] = useState(false);
  // const [isChecked, setIsChecked] = useState(props.value.requerido);

  const dispatch = useDispatch();

  const handleCheckbox = ({ target: { checked, value: checkValue } }) => {
    if (checked) {
      // const value = JSON.parse(checkValue);
      const _req1 = {
        requerido: true,
        descripcion: props.value.descripcion,
      };
      props.setIsDisable(true);
      dispatch(
        editEvaluationTypeCheck(_req1, props.value.id, props.index, setLoading)
      );
    } else {
      const _req2 = {
        requerido: false,
        descripcion: props.value.descripcion,
      };
      props.setIsDisable(false);
      dispatch(
        editEvaluationTypeCheck(_req2, props.value.id, props.index, setLoading)
      );
    }
  };
  return (
    <>
      {/* {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : ( */}
      <div className="d-flex flex-wrap justify-content-start align-items-center">
        {/* <FormLabel className="mb-0 text-muted" for={`check ${props.value.id}`}>
          {isChecked ? "Si" : "No"}
        </FormLabel> */}
        <Form.Check
          id={`check ${props.value.id}`}
          name={`check ${props.value.id}`}
          onChange={handleCheckbox}
          className="ml-2 rounded-pill"
          type="switch"
          value={props.value.requerido}
          disabled={props.isDisable}
          defaultChecked={props.value.requerido}
        />
      </div>
      {/* )} */}
    </>
  );
};

export default CheckRequired;
